import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// import ReactGA from 'react-ga4';
import { logPageView } from '../../analytics';

function PageTracker({ analyticsKey }) {
  const location = useLocation();

  useEffect(() => {
    if (analyticsKey && analyticsKey !== '<-ANALYTICS-KEY->' && window.gtag) {
      logPageView(location.pathname + location.search);
    }
  }, [location, analyticsKey]);

  return null;
}

export default PageTracker;
